(() => {
  if (window.scProductCertificateBadgeNavigationInitialized) return;

  window.scProductCertificateBadgeNavigationInitialized = true;

  const badgeSelector = "[data-sc-certificate-badge-navigation]";
  const accordionSelector = ".product-tabs__tab-item-wrapper";
  const topObstructionSelector = [
    ".shopify-section--announcement-bar",
    ".shopify-section--header",
    "product-sticky-form:not([hidden])",
  ].join(",");
  const scrollGap = 8;

  const normalizeTitle = (value) =>
    String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const destinationTitles = new Set(
    ["Material & Zertifizierungen", "Material & Certifications"].map(
      normalizeTitle
    )
  );

  const hasDestinationTitle = (element) =>
    destinationTitles.has(normalizeTitle(element?.textContent));

  const isVisible = (element) => {
    if (!element) return false;

    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      styles.display !== "none" &&
      styles.visibility !== "hidden" &&
      rect.width > 0 &&
      rect.height > 0
    );
  };

  const findTitleActivator = (selector, visibleOnly) =>
    Array.from(document.querySelectorAll(selector)).find(
      (element) =>
        hasDestinationTitle(element) && (!visibleOnly || isVisible(element))
    );

  const findAccordionDestination = (visibleOnly) => {
    const activator = findTitleActivator(
      `${accordionSelector} .collapsible-toggle`,
      visibleOnly
    );

    if (!activator) return null;

    return {
      activator,
      scrollTarget: activator.closest(accordionSelector) || activator,
    };
  };

  const findTabDestination = (visibleOnly) => {
    const activator = findTitleActivator(
      "[data-sc-product-tabs-button]",
      visibleOnly
    );

    if (!activator) return null;

    return {
      activator,
      scrollTarget: activator.closest("sc-product-tabs") || activator,
    };
  };

  const findDestination = () =>
    findAccordionDestination(true) ||
    findTabDestination(true) ||
    findAccordionDestination(false) ||
    findTabDestination(false);

  const openDestination = (activator) => {
    if (!activator) return;

    const isAccordion = activator.matches(".collapsible-toggle");
    const isTab = activator.matches("[data-sc-product-tabs-button]");

    if (isAccordion && activator.getAttribute("aria-expanded") !== "true") {
      activator.click();
    } else if (isTab && activator.getAttribute("aria-selected") !== "true") {
      activator.click();
    }
  };

  const getTopObstructionBottom = () => {
    const tolerance = 2;
    const documentStyles = window.getComputedStyle(document.documentElement);
    const getDocumentStyleNumber = (property) =>
      parseFloat(documentStyles.getPropertyValue(property)) || 0;
    const stickyChromeBottom =
      getDocumentStyleNumber("--header-height") *
        getDocumentStyleNumber("--enable-sticky-header") +
      getDocumentStyleNumber("--announcement-bar-height") *
        getDocumentStyleNumber("--enable-sticky-announcement-bar");
    const candidates = Array.from(
      document.querySelectorAll(topObstructionSelector)
    )
      .map((element) => {
        const styles = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();

        return { styles, rect };
      })
      .filter(
        ({ styles, rect }) =>
          ["fixed", "sticky"].includes(styles.position) &&
          styles.display !== "none" &&
          styles.visibility !== "hidden" &&
          rect.width > 0 &&
          rect.height > 0 &&
          rect.bottom > 0 &&
          rect.top < window.innerHeight
      )
      .sort((first, second) => first.rect.top - second.rect.top);

    return candidates.reduce((obstructionBottom, { rect }) => {
      if (rect.top > obstructionBottom + tolerance) return obstructionBottom;

      return Math.max(obstructionBottom, rect.bottom);
    }, stickyChromeBottom);
  };

  const alignScrollTarget = (scrollTarget, behavior) => {
    const desiredTop = getTopObstructionBottom() + scrollGap;
    const targetTop = scrollTarget.getBoundingClientRect().top;
    const top = window.scrollY + targetTop - desiredTop;

    if (Math.abs(targetTop - desiredTop) <= 1) return;

    window.scrollTo({ top: Math.max(0, top), behavior });
  };

  const scrollToDestination = ({ activator, scrollTarget }) => {
    openDestination(activator);

    window.setTimeout(() => {
      activator?.focus({ preventScroll: true });

      const behavior = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches
        ? "auto"
        : "smooth";

      alignScrollTarget(scrollTarget, behavior);

      if (behavior === "smooth" && "onscrollend" in window) {
        window.addEventListener(
          "scrollend",
          () => alignScrollTarget(scrollTarget, "auto"),
          { once: true }
        );
      }

      window.setTimeout(
        () => alignScrollTarget(scrollTarget, "auto"),
        behavior === "smooth" ? 1000 : 300
      );
    }, 50);
  };

  const navigateFromBadge = () => {
    const destination = findDestination();
    if (destination) scrollToDestination(destination);
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const badge = event.target.closest(badgeSelector);
    if (!badge) return;

    navigateFromBadge();
  });
})();
